var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Sorting',{attrs:{"direction":_vm.sortDirection},on:{"sort":_vm.onSort}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }